import { Language } from "movieapi";
import * as React from "react";
import LanguageTable from "./LanguageTable";
// tslint:disable-next-line:no-empty-interface
export interface IChooseLanguagesProps {
  data: Language[] | undefined;
  handleLanguageChange: (languages: Language[]) => void;
}

// tslint:disable-next-line:no-empty-interface
export interface IChooseLanguagesState {}

export default class ChooseLanguages extends React.Component<
  IChooseLanguagesProps,
  IChooseLanguagesState
> {
  constructor(props: IChooseLanguagesProps) {
    super(props);

    this.state = {};
  }

  public render() {
    return (
      <div>
        <p>
          Choose the three most common languages in your movie ranked by how
          common the language is.
        </p>
        <p>
          For example if the movie is in English but has several seens in Arabic
          you should choose English and then Arabic. You can leave fields blank
          if there are fewer than three languages.
        </p>
        <LanguageTable
          data={this.props.data}
          handleLanguageChange={this.props.handleLanguageChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PredictionPage/ChooseLanguages.tsx